import { Container, Row, Col } from 'react-bootstrap';
import { PageTitle } from 'shared/components/Fonts';
import { useNotifications } from 'shared/notifications';
import { CrearCentroCostoRequest } from 'core/cuenta/models/requests/CrearCentroCostoRequest';
import { useCoreService } from 'core/services/useCoreService';
import {
  CostCentreForm,
  CostCentreFormData,
} from 'core/centrocosto/components/CostCentreForm/CostCentreForm';
import { COST_CENTRE_LIST_PATH } from 'core/centrocosto/routes';
import { useNavigate } from 'react-router-dom';
import { IconName } from '@orbita-ui/core';
import { CustomBreadcrumb } from 'shared/components/CustomBreadcrumb';
import { useState } from 'react';
import {
  DEFAULT_SAVE_COST_CENTRE_API_ERRORS,
  SAVE_COST_CENTRE_ERROR_MESSAGES,
} from 'core/centrocosto/constants/SaveCostCentreMessages';
import { useImpersonationGuard } from 'auth/hooks/useImpersonationGuard';

export function CostCentreCreatePage() {
  const breadcrumbData: {
    icon: IconName;
    items: string[];
    lastItem: string;
  } = {
    icon: 'BankIcon',
    items: ['Organización'],
    lastItem: 'Crear centro de costos',
  };

  const coreService = useCoreService();
  const { addNotification } = useNotifications();
  const navigate = useNavigate();
  const { guardWriteAction } = useImpersonationGuard();
  const [isLoading, setIsLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState(DEFAULT_SAVE_COST_CENTRE_API_ERRORS);

  const handleSubmit = async (formData: CostCentreFormData) => {
    if (!guardWriteAction()) {
      return;
    }
    const request = new CrearCentroCostoRequest({
      centroCostoPadreId: formData.centroCosto.value.id,
      denominacion: formData.denominacion,
      numeroCuenta: formData.cuenta.value.numeroCuenta,
    });

    setIsLoading(true);
    try {
      await coreService.createCostCentre(request);
      addNotification('Centro de costo creado con éxito', 'success');
      navigate(COST_CENTRE_LIST_PATH);
    } catch (error) {
      const errorKey = error.apiError.message;

      if (errorKey in DEFAULT_SAVE_COST_CENTRE_API_ERRORS) {
        setApiErrors({ ...DEFAULT_SAVE_COST_CENTRE_API_ERRORS, [errorKey]: true });
      } else {
        // Error no manejado
        addNotification(SAVE_COST_CENTRE_ERROR_MESSAGES.default, 'error');
        setApiErrors(DEFAULT_SAVE_COST_CENTRE_API_ERRORS);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container fluid>
      <CustomBreadcrumb
        icon={breadcrumbData.icon}
        items={breadcrumbData.items}
        lastItem={breadcrumbData.lastItem}
      />
      <Row className="mb-3 d-flex justify-content-between align-items-center">
        <Col>
          <PageTitle>Crear Centro de Costos</PageTitle>
        </Col>
      </Row>
      <Row>
        <CostCentreForm
          onSubmit={handleSubmit}
          submitLabel="Crear"
          isLoading={isLoading}
          apiErrors={apiErrors}
        />
      </Row>
    </Container>
  );
}
